import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INTERESTS = ["Biscuits — bulk / distribution", "Confectionery", "Merchant export partnership", "Other"];

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", country: "", interest: INTERESTS[0], message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/contact`, form);
      if (data.ok) {
        toast.success("Enquiry received — the export desk will reply within one business day.", { duration: 5000 });
        setForm({ name: "", email: "", phone: "", company: "", country: "", interest: INTERESTS[0], message: "" });
      } else {
        toast.error("Something went wrong. Please WhatsApp us instead.");
      }
    } catch {
      toast.error("Could not send right now — please WhatsApp or call us.");
    } finally {
      setSending(false);
    }
  };

  const field = "h-11 rounded-lg border-brand-line bg-white/80 focus-visible:ring-brand-red";

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label htmlFor="cf-name" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Name *</Label>
          <Input id="cf-name" required value={form.name} onChange={set("name")} data-testid="contact-input-name" placeholder="Your full name" className={field} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cf-company" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Company</Label>
          <Input id="cf-company" value={form.company} onChange={set("company")} data-testid="contact-input-company" placeholder="Trading / distribution company" className={field} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cf-email" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Email</Label>
          <Input id="cf-email" type="email" value={form.email} onChange={set("email")} data-testid="contact-input-email" placeholder="you@company.com" className={field} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cf-phone" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Phone / WhatsApp</Label>
          <Input id="cf-phone" value={form.phone} onChange={set("phone")} data-testid="contact-input-phone" placeholder="+00 000 000 0000" className={field} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cf-country" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Country</Label>
          <Input id="cf-country" value={form.country} onChange={set("country")} data-testid="contact-input-country" placeholder="Country of import" className={field} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cf-interest" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Interested in</Label>
          <select
            id="cf-interest"
            value={form.interest}
            onChange={set("interest")}
            data-testid="contact-select-interest"
            className="h-11 w-full rounded-lg border border-brand-line bg-white/80 px-3 text-sm text-brand-ink focus:outline-none focus:ring-1 focus:ring-brand-red"
          >
            {INTERESTS.map((i) => (
              <option key={i} value={i}>{i}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="cf-message" className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Message *</Label>
        <Textarea id="cf-message" required value={form.message} onChange={set("message")} data-testid="contact-input-message" placeholder="Products, grammages, quantities, destination port…" className="min-h-32 rounded-lg border-brand-line bg-white/80 focus-visible:ring-brand-red" />
      </div>
      <Button
        type="submit"
        disabled={sending}
        data-testid="contact-submit-button"
        className="h-12 w-full sm:w-auto rounded-full bg-brand-red px-10 text-sm font-bold text-brand-cream hover:bg-brand-choc"
      >
        {sending ? "Sending…" : "Send enquiry"}
      </Button>
    </form>
  );
};

export default ContactForm;
